import React, { Component } from 'react'
import LikeButton from '../buttons/LikeButton'
import PollButton from '../buttons/PollButton'
import PollResults from '../results/PollResults'
import { formatDate, Auth } from '../../../../helpers'
import './Poll.css'

class Poll extends Component {
  likeText () {
    if (!this.props.details.likes) return '0 enjoys'
    if (this.props.details.likes.length === 1) {
      return '1 enjoy'
    }
    return `${this.props.details.likes.length} enjoys`
  }

  isVotingLocked () {
    if (this.props.details.votes) {
      const index = this.props.details.votes.findIndex(a => a.participant === Auth.getParticipant())
      if (index === -1) return ''
      return this.props.details.votes[index].vote
    }
    return ''
  }

  render () {
    return (
      <div className='poll-all-wrap'>
        <div className='question-wrap'>
          <div className='body-right-wrap'>
            <div className='name-wrap'>
              <span>
                {this.props.details.title}
                {Auth.isAdmin() && <img
                  onClick={this.props.onEdit}
                  src='/imgs/pencil.png'
                  alt='EDIT POLL'
                  className='edit-bttn' />}
              </span>
              <span className='text-time'>{formatDate(this.props.details.createdAt)}</span>
            </div>
            <div className='text-wrap'>
              <span> {this.props.details.text.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)} </span>
            </div>
            {!(this.props.details.pollType === 'open' && Auth.isAdmin()) &&
              <div className='buttons-wrap no-padding voting-bttns'>
                <PollButton
                  onAnswer={(answer) => {
                    if (this.props.onAnswerChange) {
                      this.props.onAnswerChange.call(null, answer)
                    }
                  }}
                  locked={this.isVotingLocked()}
                  poll={this.props.details} />
              </div>
            }
            {Auth.isAdmin() && <PollResults poll={this.props.details} />}
            <div className='buttons-wrap poll-like-bttn'>
              <LikeButton
                text={this.likeText()}
                active={this.props.activeLike}
                onClick={() => {
                  this.props.onLikeChange && this.props.onLikeChange.call(null, !this.props.activeLike)
                }} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Poll



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/comments/Poll.js